jQuery("#back-top").hide();
jQuery(function () {
    jQuery(window).scroll(function () {
        if (jQuery(this).scrollTop() > 1000) {
            jQuery('#back-top').fadeIn();
            jQuery("#back-top").addClass('active');
        } else {
            jQuery('#back-top').fadeOut();
            jQuery("#back-top").removeClass('active');
        }
    });
    jQuery('#back-top').click(function () {
        jQuery('body,html').animate({
            scrollTop: 0
        }, 1000);
        return false;
    });
});


window.onscroll = function () { myFunction() };
var header = document.getElementById("header");
if (header != null) {
    var sticky = header.offsetTop;
}
function myFunction() {
    if (window.pageYOffset > sticky) {
        header.classList.add("fixed");

    } else {
        header.classList.remove("fixed");
    }
}
/**********************footer menu ********************** */

jQuery(document).on("click", ".collapse-menu h4", function (e) {
    jQuery(this).parents(".collapse-menu").find(".menu-collapse-wrap").slideToggle("slow");
    jQuery(this).parents(".collapse-menu").toggleClass("menushow");
});

/********************** Mobile menu ********************** */
jQuery(document).on("click", ".navbar-toggler,.close-menu", function (e) {
    jQuery(jQuery(this).attr('data-target')).toggleClass("show");
});


function lazyloader() {
    const lazyContent = new LazyLoad({
        elements_selector: ".lazy"
    });

    const lazyBackground = new LazyLoad({
        elements_selector: "iframe.lazy, video.lazy, div.lazy, section.lazy, button.lazy,header.lazy"
    });
}

$(document).ready(function () {
    lazyloader();
    //side menu
    const $sideMenu = $('#sideMenu');
    const $toggleButton = $('#toggleSideMenu');
    const $menuOpenIcon = $('#menuOpenIcon');
    const $menuCloseIcon = $('#menuCloseIcon');

    $toggleButton.on('click', function (e) {
        e.stopPropagation(); // Prevent the click from bubbling up to the document
        $sideMenu.toggleClass('-translate-x-full');
        $menuOpenIcon.toggleClass('hidden');
        $menuCloseIcon.toggleClass('hidden');
    });

    $(document).on('click', function (event) {
        if (!$sideMenu.is(event.target) && $sideMenu.has(event.target).length === 0 && !$toggleButton.is(event.target) && !$toggleButton.has(event.target).length) {
            $sideMenu.addClass('-translate-x-full');
            $menuOpenIcon.removeClass('hidden');
            $menuCloseIcon.addClass('hidden');
        }
    });

    // Loop through each tab container to set up independent tabs
    $('.tab-container').each(function () {
        const $container = $(this);
        const $tabButtons = $container.find('.tab-button');
        const $tabContentItems = $container.find('.tab-content-item');

        // Set up click event for each button within this container
        $tabButtons.on('click', function () {
            const $button = $(this);
            const target = $button.data('tab');

            // Remove active class from all buttons and add to clicked button
            $tabButtons.removeClass('active');
            $button.addClass('active');

            if (target != "all") {
                // Add fade effect to content items
                $tabContentItems.filter(':visible').fadeOut(200, function () {
                    $tabContentItems.addClass('hidden');
                    $tabContentItems.filter(`[data-content="${target}"]`).removeClass('hidden').fadeIn(200);
                });
            } else {
                $tabContentItems.removeClass('hidden').fadeIn(200);
            }
        });
    });


    $('.accordion-group').each(function () {
        const $accordionGroup = $(this);

        // Open the first item by default in each group
        $accordionGroup.find('.accordion-item:first-child .accordion-content').show();
        $accordionGroup.find('.accordion-item:first-child .accordion-icon').text('-');

        // Toggle functionality for each accordion item
        $accordionGroup.find('.accordion-toggle').click(function () {
            $(".accordion-item").removeClass('active');
            // Close other items in the current group and reset icons to "+"
            $accordionGroup.find('.accordion-content').not($(this).next()).slideUp();
            $accordionGroup.find('.accordion-icon').not($(this).find('.accordion-icon')).text('+');
            $(this).parents('.accordion-item').addClass('active');
            // Toggle current item and icon
            $(this).next().slideToggle();
            const icon = $(this).find('.accordion-icon');
            icon.text(icon.text() === '+' ? '-' : '+');
        });
    });

    $('.category-filter button').on('click', function () {
        const $button = $(this);
        const char = $button.data('cat');
        if (char == 'All') {
            $('.category-filter button').removeClass('active');
            $('.area-items').removeClass('hidden');
            $('.show-all-btn').addClass('active');
        } else {
            $('.category-filter button').removeClass('active');
            $button.addClass('active');
            $('.area-items').addClass('hidden');
            $('.area-items').filter(`[data-filter="${char}"]`).removeClass('hidden');
        }
        $('.noresult').hide();
        $('.alphabet-filter button').removeClass('active');
    });

    $('.alphabet-filter button').on('click', function () {
        const $button = $(this);
        const char = $button.data('char');
        $('.alphabet-filter button').removeClass('active');
        $button.addClass('active');
        $('.area-items').addClass('hidden');
        $('.area-items').filter(`[data-char="${char}"]`).removeClass('hidden');
        $('.category-filter button').removeClass('active');
        $('.show-all-btn').addClass('active');

        if ($('.area-items').filter(`[data-char="${char}"]`).length === 0) {
            $('.noresult').show();
        } else {
            $('.noresult').hide();
        }
    });


    $('.testimonials-slider').slick({
        slidesToShow: 3,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 500,
        cssEase: 'linear',
        infinite: true,
        focusOnSelect: false,
        dots: false,
        // variableWidth: true,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    variableWidth: true,
                },
            },

        ],
    });

    $('.services-slider').slick({
        slidesToShow: 3,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 3000,
        speed: 500,
        cssEase: 'linear',
        infinite: true,
        focusOnSelect: false,
        dots: false,
        variableWidth: true,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 568,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    });

    if ($(window).width() < 767) {
        $('.cta-mobile-slider').slick({
            slidesToShow: 1,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 5000,
            speed: 500,
            cssEase: 'linear',
            infinite: true,
            focusOnSelect: false,
            dots: false,
            variableWidth: true,

        });
        $('.tab-item-slider').slick({
            slidesToShow: 1,
            arrows: false,
            autoplay: false,
            autoplaySpeed: 5000,
            speed: 500,
            cssEase: 'linear',
            infinite: true,
            focusOnSelect: false,
            dots: false,
            variableWidth: true,
        });
    }


});